import Spinner from "@/components/base/Spinner.tsx";

export const LoadingPage = () => (
  <div className="flex flex-grow items-center justify-center">
    <Spinner />
  </div>
);
